import { useState } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import PreVisualizacaoTemplate from './index.template';
import RadioGroup from '@componentsNew/Analises/RadioGroup';

function PreVisualizacao({ nota }) {
  const [valorInputRadio, setValorInputRadio] = useState('mobile');

  const blogData = useSelect(select => select('core').getSite());
  const { title: nomeBlog } = blogData || {};

  return (
    <div>
      <RadioGroup
        nota={nota}
        valorInputRadio={valorInputRadio}
        setValorInputRadio={setValorInputRadio}
        label="Pré - visualização Google"
        group="pre-visualizacao"
        opcoes={[
          { valor: 'mobile', titulo: 'Mobile' },
          { valor: 'desktop', titulo: 'Desktop' },
        ]}
      >
        <PreVisualizacaoTemplate
          nomeBlog={nomeBlog}
          valorInputRadio={valorInputRadio}
        />
      </RadioGroup>
    </div>
  );
}

export default PreVisualizacao;
